<template>
	<div :class="['packagelist', showthreadwin? 'markdiv' : '']">
		<el-card>
			<el-tabs v-model="activetab" @tab-click="GetTabData">
				<el-tab-pane :label="tab.name" :name="tab.name" v-for="tab in tabs" :key="tab.l_id">
					<span slot="label">{{ tab.name }} ({{ tab.count }})</span>
					<el-row>
						<el-col :span="17">
							<handlerbutton :handlerlist="tab.buttons" @buttonhandle="buttonhandle"></handlerbutton>
							<span style="color:transparent" v-if="tab.buttons.length < 1">占位</span>
						</el-col>
						<el-col :span="1" class="rightcol"><el-button icon="el-icon-refresh-right" circle size="mini" @click.native="ResetFilterInfo()"></el-button></el-col>
						<el-col :span="4"><el-input placeholder="搜索" v-model="searchbox" size="small" @keyup.enter.native="refreshgrid(true)"></el-input></el-col>
						<el-col :span="2" class="rightcol">
							<el-popover placement="bottom-end" :width="filterlist.length > 0 ? 580 : 350" trigger="click">
								<table class="htmltable">
									<tr>
										<td><label>订单号</label></td>
										<td><el-input type="textarea" rows="3" v-model="searchlist.p_pkval" size="mini"></el-input></td>
										<td rowspan="5" valign="top" class="filter" v-if="filterlist.length > 0">
											<div>常用筛选</div>
											<ul>
												<li v-for="(item, index) in filterlist">
													<el-radio v-model="searchlist.fname" :label="item.fname" @change="Setfilterchecked">{{ item.fname }}</el-radio>
												</li>
											</ul>
										</td>
									</tr>
									<tr>
										<td><label>快递单号</label></td>
										<td>
											<el-input type="textarea" rows="3" v-model="searchlist.expressid" size="mini"></el-input>
										</td>
									</tr>
									<tr>
										<td><label>渠道</label></td>
										<td>
											<el-select v-model="searchlist.p_mode" 
											filterable size="mini" clearable style="width:250px;">
											    <el-option
											      v-for="it in pmodecolsource"
											      :key="it.title"
											      :label="it.title"
											      :value="it.title" 
												  >
											    </el-option>
											</el-select>
										</td>
									</tr>
									<tr>
										<td><label>批次号</label></td>
										<td><el-input v-model="searchlist.p_batch" size="mini"></el-input></td>
									</tr>
									<tr>
										<td><label>出库批次号</label></td>
										<td><el-input type="textarea" rows="3" v-model="searchlist.outbatch" size="mini"></el-input></td>
									</tr>
									<tr>
										<td><label>提单号</label></td>
										<td><el-input v-model="searchlist.p_airwaybill" size="mini"></el-input></td>
									</tr>
									<tr>
										<td><label>新增人账号</label></td>
										<td><el-input v-model="searchlist.u_account" size="mini"></el-input></td>
									</tr>
									<tr>
										<td><label>下单时间</label></td>
										<td style="text-align:left;">
											<el-date-picker
												v-model="searchlist.starttime"
												type="date"
												placeholder="选择开始日期"
												size="mini"
												value-format="yyyy-MM-dd"
											></el-date-picker>
										</td>
									</tr>
									<tr>
										<td><label>至</label></td>
										<td style="text-align:left;">
											<el-date-picker
												v-model="searchlist.endtime"
												type="date"
												placeholder="选择结束日期"
												size="mini"
												value-format="yyyy-MM-dd"
											></el-date-picker>
										</td>
									</tr>
									<tr>
										<td colspan="4" class="bottombtn">
											<el-button @click="GetTabData()" type="warning" size="mini">查询</el-button>
											<el-button @click="ClearSearch(0)" size="mini">清空</el-button>
										</td>
									</tr>
								</table>

								<el-link slot="reference" type="primary">更多筛选</el-link>
							</el-popover>
						</el-col>
					</el-row>
					<el-row style="height:10px;"></el-row>
					<el-row>
						<el-col :span="24">
							<tableexpand
								v-if="tab.isgridexpand"
								style="width:100%;"
								v-loading="loading"
								ref="packagetableexpand"
								:tableData="packagelist"
								:columns="tab.columns"
								@gridhandle="gridhandle"
								:gridheight="gridheight"
								@gridsort="gridsort"
								@checkboxchange="checkboxchange"
								@gridscroll="gridscroll"
								@rowdblclick="rowdblclick"
								:istop="istop"
								:soncolumns="tab.soncolumns"
								:isexpand="isexpand"
								@getExpandsRow="getExpandsRow"
								:rowkey="rowkey"
							></tableexpand>
						</el-col>
					</el-row>
				</el-tab-pane>
			</el-tabs>
		</el-card>
		<printhandler ref="printhandler" @printcallback="printcallback"></printhandler>
		<pastorderwin ref="pastorderwin" @pastorderhandler="pastorderhandler"></pastorderwin>
		<interceptwin ref="interceptwin"></interceptwin>
		<exportwin ref="exportwin"></exportwin>
		<importwin ref="importwin"></importwin>
		<BatchUpdate ref="BatchUpdate"></BatchUpdate>
		<downmd ref="downmd"></downmd>
		<exportxml_clear ref="exportxml_clear"></exportxml_clear>
		<createstep ref="createstep"></createstep>
		<pushwl ref="pushwl"></pushwl>
		<downorder ref="downorder"></downorder>
		<!-- 	<submitqg ref="submitqg"></submitqg> -->
		<div v-if="showthreadwin" style="height:200px;width:400px;text-align:center;z-index:99999;position:absolute;top:30%;left:35%;padding-top:40px;background-color:#ffffff;" class="bordershadow">
			<el-progress type="circle" :percentage="handlerpercent" color="#199621"></el-progress>
		</div>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';	
import handlerbutton from '@/components/handlerbutton/handler.vue';
import tableexpand from '@/components/table/tablegrid_expand.vue';
import pastorderwin from '@/components/order/pastorderwin.vue';
import printhandler from '@/components/order/printhandler_check.vue';
import exportwin from '@/components/order/exportwin.vue';
import interceptwin from '@/components/order/interceptwin.vue';
import importwin from '@/components/order/importwin.vue'; //万能导入
import BatchUpdate from '@/components/order/BatchUpdate.vue';
import downmd from '@/components/order/downmd.vue';
import exportxml_clear from '@/components/order/exportxml_clear.vue';
import createstep from '@/components/orderset/createstep.vue';//生成物流
import pushwl from '@/components/order/pushwl.vue';//推送物流
import downorder from '@/components/order/downorder.vue';//平台下载订单
// import submitqg from '@/components/qg/submitqg.vue';//平台下载订单
export default {
	components: {
		tableexpand,
		handlerbutton,
		pastorderwin,
		printhandler,
		exportwin,
		interceptwin,
		importwin,
		BatchUpdate,
		downmd,
		exportxml_clear,
		createstep,
		pushwl,
		downorder,
		//submitqg
	},
	data() {
		return {
			showthreadwin:false,
			errorfilename:'',
			handlercount:0,
			allcount:0,
			handlerpercent:0,
			threadparaminfo:'',//多线程操作的参数
			changetime:'',
			searchlist: {
				p_pkval: '',
				expressid: '',
				p_batch: '',
				cname: '',
				starttime: '',
				endtime: '',
				fixfilter: '',
				fixsort: '',
				fname:'',
				outbatch:''
			},
			istop: false,
			searchbox: '',
			type: '',
			pickerOptions: '',
			packagelist: [],
			gridheight: (window.innerHeight * 66) / 100 + 'px',
			activeName: '',
			activetab: '',
			activeTabIndex: 0, //激活的选项卡index
			loading: false,
			pageindex: 0,
			pagesize: 200,
			search: '',
			sort: '',
			tabs: [],
			mode: '包裹管理', //当前操作的功能模块名称
			filterlist: [], //常用筛选条件
			selectedall: false,
			checkedrow: [],
			batch: '',
			divclass: 'packagelist',
			showpdf: '',
			showsuccesswin: false,
			isloadscroll: false,
			rowkey: 'groupid',
			isexpand: true, //默认展开
			soncolumns: [],
			pmodecolsource:[]
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/packagemanager/packagecss.scss');
			//debugger
			this.getTabs();
		});
		var that = this;
		Utils.$on('refreshgrid', function(msg) {
			that.refreshgrid(true);
		});
	},
	methods: {
		//获取选项卡
		getTabs() {
			var that = this;
			this.GetClarance();
			this.$apipost.get.GetTabs({ parentid: 2 }).then(res => {
				if (res.tabs != undefined) {
					res.tabs.forEach(e => {
						e.isgridexpand = false;
						if (e.type.indexOf('_expand') > -1) {
							e.isgridexpand = true;
						}
					});
					that.tabs = res.tabs;
					let tab = this.tabs[0];
					that.activeName = tab.type;
					that.activetab = tab.name;
					that.GetTabData();
				} else {
					that.getTabs();
				}
			});
		},
		GetClarance() {
			var that = this;
			//先加载渠道
			this.$apipost.get.GetClarance().then(res => {
				debugger
				that.pmodecolsource = res.list;
			});
		},
		//清空筛选条件
		ClearSearch(type) {
			this.searchlist = {
				p_pkval: '',
				expressid: '',
				p_batch: '',
				cname: '',
				starttime: '',
				endtime: '',
				fixfilter: '',
				fname:'',
				name: '',
				outbatch:'',
				p_mode:''
			};
			if (type == 1) {
				this.searchbox = '';
			}
		},
		//获取表头方法
		GetTabData(tab) {
			if (tab != undefined) {
				this.activeTabIndex = tab.index;
				this.activeName = this.tabs[this.activeTabIndex].type;
				this.activetab = this.tabs[this.activeTabIndex].name;
			}
			this.GetFilter(); //加载选项卡对应的筛选条件
			this.GetPackageCount(); //获取汇总数
			if (this.tabs[this.activeTabIndex].columns.length == 0) {
				this.GetColumns();
			} else {
				this.refreshgrid(true);
			}
		},
		//滚动加载列表
		gridscroll(e) {
			if (e != undefined) {
				var that = this;
				const scrollDistance = e.event.target.scrollHeight - e.e.scrollTop - e.event.target.offsetHeight;
				//console.log(scrollDistance);
				if (scrollDistance <= 84) {
					//debugger
					that.refreshgrid(false);
				}
			}
		},
		//刷新列表
		refreshgrid(isrefresh) {
			this.showthreadwin=false;
			var that = this;
			this.istop = false;
			var isload = true;
			if (isrefresh) {
				this.packagelist = [];
				this.checkedrow = [];
				//刷新
				this.pageindex = 0;
				this.istop = true;
			} else {
				//加载下一页
				if (parseInt(this.tabs[this.activeTabIndex].pagecount - 1) > this.pageindex) {
					this.pageindex = this.pageindex + 1;
				} else {
					isload = false;
				}
			}
			if (isload) {
				this.loading = true;
				this.$apipost.get
					.GetPackageList({
						search: this.GetSearchObj(),
						tab: this.tabs[this.activeTabIndex].type,
						pageindex: this.pageindex,
						pagesize: this.pagesize,
						sort: this.sort,
						l_mode: this.mode,
						showcol: JSON.stringify(this.tabs[this.activeTabIndex].columns)
					})
					.then(res => {
						//console.log('加载次数');
						//console.log('res',JSON.stringify(res.data));
						that.loading = false;
						if (isload && !that.isloadscroll) {
							that.gridscroll();
						}
						res.data=that.SetGridChild(res.data);
						if (res.data.length > 0) {
							if (that.pageindex > 0) {
								that.packagelist = that.packagelist.concat(res.data);
							} else {
								that.packagelist = res.data;
							}
						}
						if(that.$refs.packagetableexpand.length>=parseInt(that.activeTabIndex) ){
							if(that.$refs.packagetableexpand[that.activeTabIndex]!=undefined)
								that.$refs.packagetableexpand[that.activeTabIndex].SetTableList(that.packagelist);
						}
					});
				if(isrefresh)
					that.GetPackageCount(); //获取汇总数
			}
		},
		SetGridChild(list){
			list.forEach(e=>{
				if(e.haschild=='1')
					e.sonDataList=[];
			});
			return list;
		},
		//组合筛选条件
		GetSearchObj() {
			var search = JSON.parse(JSON.stringify(this.searchlist));
			if (search.fname != '') {
				var that = this;
				var searchtype = '';
				this.filterlist.forEach(e => {
					if (e.fname == search.fname) {
						if (e.handlertype == 'filter') {
							searchtype = e.searchtype;
							search.fixfilter=e.filter;
							return false;
						} else if (e.handlertype == 'sort') {
							searchtype = '';
							search.fixfilter = '';
							search.fixsort = e.filter;
							return false;
						}
					}
				});
				search.searchtype = searchtype;
			}
			search.p_pkval = search.p_pkval.replace(/\n/g, ',');
			search.expressid = search.expressid.replace(/\n/g, ',');
			if (this.searchbox != '') {
				search.searchbox = this.searchbox;
			}
			return JSON.stringify(search);
		},
		//获取列配置信息
		GetColumns() {
			var that = this;
			this.$apipost.get.GetColumns({ tab: this.tabs[this.activeTabIndex].type, checkfield: 1, parentid: this.tabs[this.activeTabIndex].id, mode: this.mode }).then(res => {
				//console.log('列配置',JSON.stringify(res));
				that.tabs[that.activeTabIndex].columns = res;
				if (that.tabs[this.activeTabIndex].type.indexOf('_expand') > -1) {
					//设置子表的列配置，去掉勾选、去掉模板列
					var colums = res.filter(function(e) {
						return e.type != '' && e.type != 'template';
					});
					that.tabs[that.activeTabIndex].soncolumns = colums;
				}
				that.refreshgrid(true);
			});
		},
		//获取包裹管理汇总表
		GetPackageCount() {
			
			var that = this;
			var type = this.tabs[this.activeTabIndex].type;
			//debugger;
			this.$apipost.get.GetPackageCount({ tab: type, search: this.GetSearchObj() }).then(res => {
				if (res.state == '1') {
					for (var i = 0; i < that.tabs.length; i++) {
						if (type != '历史订单') {
							var countlist = res.countlist[0];
							for (var e in countlist) {
								if (e == that.tabs[i].type) {
									that.tabs[i].count = countlist[e];
									break;
								}
							}
						} else {
							var countlist = res.countlist[0];
							if (countlist[type] != undefined) {
								that.tabs[i].count = countlist[type];
								break;
							}
						}
					}
					that.setpagecount();
				}
			});
		},
		//设置分页显示数
		setpagecount() {
			var tabs = this.tabs;
			tabs.forEach(e => {
				if (parseInt(e.count) % this.pagesize == 0) {
					e.pagecount = parseInt(e.count) / this.pagesize;
				} else {
					e.pagecount = parseInt(parseInt(e.count) / this.pagesize) + 1;
				}
			});
		},
		//列表排序
		gridsort(e) {
			//e.column.prop--排序列名
			//e.column.order--ascending/descending --排序方式
			this.sort = ' ' + e.column.prop + ' ' + e.column.order.replace('ending', '');
			this.refreshgrid(true);
		},
		//操作栏按钮触发事件
		buttonhandle(e) {
			var that = this;
			if (e.event == 'Inportorder') {
				//导入
				this.InportOrder(e);
			}
			if (e.event == 'delorder') {
				this.DelOrder(e);
			}
			if (e.event == 'delplan') {
				this.DelOrderPlan(e);
			}
			if (e.event == 'getmailno') {
				var searinfo = that.GetCheckedOrder(true);
				//debugger
				if (searinfo != '') {
					this.$tool.loading('正在' + e.title, 'packagelist');
					if (that.$refs.printhandler != undefined) {
						that.$refs.printhandler.init({
							pageparam: this._data,
							isgrid: true,
							pkval: '',
							searchinfo: searinfo,
							funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
							handtype: 11, //11--取单号 12 下单预览 13 下单打印
							isrollback: false,
							parentpage: this,
							isprint: 0,
							iserror:false,//操作过程中报错不显示，最后才显示
							isorder:false//是否按顺序操作，true 表示单线程按序操作， false 表示多线程操作
						});
					}
				} else {
				if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '取单号',
							l_id: e.l_id
						});
					}
				}
			}
			if (e.event == 'printorder_selectmode') {
				//按权限匹配打印模板的方式来打印，直接控件打印出来
				var searinfo = that.GetCheckedOrder(true);
				//debugger
				if (searinfo != '') {
					this.$tool.loading('正在' + e.title, 'packagelist');
					if (that.$refs.printhandler != undefined) {
						that.$refs.printhandler.init({
							pageparam: this._data,
							isgrid: true,
							pkval: '',
							searchinfo: searinfo,
							funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
							handtype: 13, //1--取单号 2--取快递单并打印 3-取快递单并预览
							isrollback: false,
							parentpage: this,
							isprint: 1,
							l_id:e.l_id
						});
					}
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '打印',
							l_id: e.l_id
						});
					}
				}
			}
			if (e.event == 'printperview_selectmode') {
				//按权限匹配打印模板的方式来打印，直接控件打印出来
				var searinfo = that.GetCheckedOrder(true);
				//debugger
				if (searinfo != '') {
					this.$tool.loading('正在' + e.title, 'packagelist');
					if (that.$refs.printhandler != undefined) {
						that.$refs.printhandler.init({
							pageparam: this._data,
							isgrid: true,
							pkval: '',
							searchinfo: searinfo,
							funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
							handtype: 12, //1--取单号 2--取快递单并打印 3-取快递单并预览
							isrollback: false,
							parentpage: this,
							isprint: 0
						});
					}
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '预览',
							l_id: e.l_id
						});
					}
				}
			}
			if (e.event == 'yubao') {
				//按权限匹配打印模板的方式来取单号
				var searinfo = that.GetCheckedOrder(true);
				if (searinfo != '') {
					this.$tool.loading('正在' + e.title, 'packagelist');
					if (that.$refs.printhandler != undefined) {
						that.$refs.printhandler.init({
							pageparam: this._data,
							isgrid: true,
							pkval: '',
							searchinfo: searinfo,
							funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
							handtype: 1, //1--取单号 2--取快递单并打印 3-取快递单并预览
							isrollback: false,
							parentpage: this,
							isprint: 0
						});
					}
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '预报',
							l_id: e.l_id
						});
					}
				}
			}
			if (e.event == 'intercept') {
				//拦截
				var searinfo = that.GetCheckedOrder(true);
				if (searinfo != '') {
					if (that.$refs.interceptwin != undefined) {
						that.$refs.interceptwin.init({ searchinfo: searinfo, pageparam: this._data });
					}
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '拦截',
							l_id: e.l_id
						});
					}
				}
			}
			if (e.event == 'cancelintercept') {
				var searinfo = that.GetCheckedOrder(true);
				if (searinfo != '') {
					that.Cancelintercept({ searchinfo: searinfo, pageparam: this._data });
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '取消拦截',
							l_id: e.l_id
						});
					}
				}
			}
			if (e.event == 'exportorder_zdy') {
				this.ExportOrder();
			}
			//万能导入
			if (e.event == 'allimport') {
				if (that.$refs.importwin != undefined) {
					that.$refs.importwin.init({
						mode: '',
						dialogtitle: e.l_name,
						isreload:true
					});
				}
			}
			//批量更新
			if (e.event == 'batchupdate') {
				var that = this;
				var searchinfo = this.GetCheckedOrder(true);
				if (searchinfo != '') {
					if (that.$refs.BatchUpdate != undefined) {
						that.$refs.BatchUpdate.init({
							title: '批量更新',
							pageparam: that._data,
							searchinfo: searchinfo,
							pkcol: 'p_pkval',
							isgrid: true
						});
					}
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '批量更新'
						});
					}
				}
			}
			//更新状态
			if (e.event == 'updatestate') {
				var that = this;
				var searchinfo = this.GetCheckedOrder(false);
				if (searchinfo != '') {
					if (that.$refs.BatchUpdate != undefined) {
						that.$refs.BatchUpdate.init({
							title: '更新状态',
							pageparam: that._data,
							searchinfo: searchinfo,
							pkcol: 'p_pkval',
							isgrid: true
						});
					}
				}
			}
			//反申报
			if (e.event == 'unsuborder') {
				var that = this;
				var searchinfo = this.GetCheckedOrder(false);
				if (searchinfo != '') {
					this.$confirm('确定反申报所选订单吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						closeOnClickModal: false
					}).then(() => {
						if (that.$refs.BatchUpdate != undefined) {
							that.$refs.BatchUpdate.init({
								title: '反申报',
								pageparam: that._data,
								searchinfo: searchinfo,
								pkcol: 'p_pkval',
								isgrid: true
							});
						}
					});
				}
			}
			//下载面单文件
			if (e.event == 'downmdfile') {
				var that = this;
				var searchinfo = this.GetCheckedOrder(true);
				if (searchinfo != '') {
					if (that.$refs.downmd != undefined) {
						that.$refs.downmd.init({
							pageparam: that._data,
							searchinfo: searchinfo
						});
					}
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '下载面单'
						});
					}
				}
			}
			if(e.event=='clearexpress'){
				var that = this;
				var searchinfo = this.GetCheckedOrder(true);
				if (searchinfo != '') {
					that.ClearExpress(searchinfo,'');
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '清空快递'
						});
					}
				}
			}
			if(e.event=='scanprint'){
				Utils.$emit('go', {
					l_url: '/packagemanange/scanprint',
					l_id: e.l_id,
					l_name: '扫描打印',
					urlparam: {}
				});
			}
			//验证号码
			if (e.event == 'verifyid') {
				var that = this;
				var searchinfo = this.GetCheckedOrder(false);
				if (searchinfo != '') {
					that.verifyid(searchinfo,'');
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '验证号码'
						});
					}
				}
			}
			if(e.event=='translationorder')
			{
				var that = this;
				var searchinfo = this.GetCheckedOrder(false);
				if (searchinfo != '') {
					that.Translationorder(searchinfo,'');
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '智能翻译'
						});
					}
				}
			}
			//下载进口清关报文
			if(e.event=='exportxml'){
				var that = this;
				var searchinfo = this.GetCheckedOrder(true);
				if (searchinfo != '') {
				if (that.$refs.exportxml_clear != undefined) {
					that.$refs.exportxml_clear.init({pageparam:this._data,searchinfo:searchinfo,batch:'',xmltype:'import'});
				}
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '生成清关报文'
						});
					}
				}
			}
			//下载出口清关报文
			if(e.event=='exportxml_export'){
				var that = this;
				var searchinfo = this.GetCheckedOrder(true);
				if (searchinfo != '') {
				if (that.$refs.exportxml_clear != undefined) {
					that.$refs.exportxml_clear.init({pageparam:this._data,searchinfo:searchinfo,batch:'',xmltype:'export'});
				}
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '生成出口报文'
						});
					}
				}
			}
			if (e.event == 'getwl') {
				this.Getwl_Batch();
			}
			//生成物流
			if(e.event=='createstep'){
				var searinfo = that.GetCheckedOrder(true);
				if(searinfo!=''){
					var paraminfo=JSON.parse(JSON.stringify(this._data));
						paraminfo.searchinfo=searinfo;
					if(that.$refs.createstep!=undefined)
						that.$refs.createstep.init({pageparam:paraminfo});
				}else{
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '生成物流',
							l_id: e.l_id
						});
					}
				}
			}
			//推送物流
			if(e.event=='pushwl'){
				var searinfo = that.GetCheckedOrder(true);
				if(searinfo!=''){
					var pageparam=that._data;
					pageparam.searchinfo=searinfo;
					if(that.$refs.pushwl!=undefined)
						that.$refs.pushwl.init({searchinfo:searinfo,pageparam:pageparam});
				}else{
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '推送物流',
							l_id: e.l_id
						});
					}
				}
			}
			if (e.event == 'add') {
				var that = this;
				this.$apipost.get.GetLinkInfo({ l_id: e.l_id }).then(res => {
					that.showratewin = false;
					if (res.info != undefined) {
						Utils.$emit('go', {
							l_url: '/packagemanange/createorder_pkg',
							l_id: e.l_id,
							l_name: e.l_name,
							urlparam: { pkval:'', iscopy: 0, l_tablename: res.info.l_tablename }
						});
					} else that.$tool.message('此功能无法启用', 0);
				});
			}
			//订单推送
			if(e.event=='orderpush'){
				var searinfo = that.GetCheckedOrder(true);
				//debugger
				if (searinfo != '') {
					this.$tool.loading('正在推送', 'packagelist');
					if (that.$refs.printhandler != undefined) {
						that.$refs.printhandler.init({
							pageparam: this._data,
							isgrid: true,
							pkval: '',
							searchinfo: searinfo,
							funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
							handtype: 11, //11--取单号 12 下单预览 13 下单打印
							isrollback: false,
							parentpage: this,
							isprint: 0,
							istransorder:true
						});
					}
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '订单推送',
							l_id: e.l_id
						});
					}
				}
			}
			//导入更新
			if(e.event == 'importupdate') {
				var that = this;
				if (that.$refs.importwin != undefined) {
					that.$refs.importwin.init({
						mode: '',
						dialogtitle: e.l_name,
						isreload:true,
						type:'update'
					});
				}
			}
			//下载订单
			if(e.event=='downorder'){
				var that = this;
				if (that.$refs.downorder != undefined) {
					that.$refs.downorder.init();
				}
			}
			//订阅物流
			if (e.event == 'subwl') {
				var that = this;
				var searchinfo = this.GetCheckedOrder(false);
				if (searchinfo != '') {
					that.SubWl(searchinfo,'');
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '订阅物流'
						});
					}
				}
			}
			if(e.event=='printset'){
				Utils.$emit('go', {
					l_url: '/user/printset',
					l_id: e.l_id,
					l_name: e.l_name,
					urlparam:{}
				});
			}
			if(e.event=='threadresolve_addr'){
				debugger
				var searinfo = that.GetCheckedOrder(false);
				if(searinfo!=''){
					this.$tool.loading('正在获取勾选数据', 'packagelist');
					this.$apipost.post.InsertTemp({ l_mode: that.mode, 
					tab: that.tabs[that.activeTabIndex].type, search: searinfo, 
					sort: that.sort }).then(res => {
						this.$tool.loadingclose();
						if (res != '') {
							if (res.batch != '') {
								debugger
								that.$public.ThreadResolve_addr2(that,res.batch);
							} else {
								this.$tool.message('获取数据失败', 0);
							}
						} else {
							this.$tool.message('获取数据失败', 0);
						}
					});	
				}
			}
			// if(e.event=='submitqg'){
			// 	var searinfo = that.GetCheckedOrder(true);
			// 	if(searinfo!=''){
			// 		var pageparam=that._data;
			// 		pageparam.searchinfo=searinfo;
			// 		if(that.$refs.submitqg!=undefined)
			// 			that.$refs.submitqg.init({searchinfo:searinfo,pageparam:pageparam});
			// 	}else{
			// 		if (that.$refs.pastorderwin != undefined) {
			// 			that.$refs.pastorderwin.init({
			// 				l_mode: that.mode,
			// 				fun: '推送清关',
			// 				l_id: e.l_id
			// 			});
			// 		}
			// 	}
			// }
		},
		SubWl(searinfo,batch){
			var that=this;
			if(searinfo!=''||batch!=''){
				var paraminfo={
					search:searinfo,
					l_mode:this.mode,
					userid:localStorage.getItem('userid'),
					tab:that.tabs[that.activeTabIndex].type,
					sort:this.sort,
					batch:batch
				}
				this.$tool.loading('正在订阅', this.divclass);
				this.$apipost.post.SubWl({ paraminfo: paraminfo }).then(res => {
					that.$tool.loadingclose();
					if(res.state=='1'){
						this.$tool.message('订阅完成', 1);
					}else
						this.$tool.message('订阅失败，请重试', 0);
				}).catch(e=>{
					that.SubWl();
				});
			}
		},
		Getwl_Batch(){
			var that=this;
			var searinfo = that.GetCheckedOrder(false);
			if(searinfo!=''){
				var paraminfo={
					pageparam:this._data,
					searchinfo: searinfo
				}
				
				this.$tool.loading('正在查询', this.divclass);
				setTimeout(function(){that.$tool.loadingclose();},2000);
				this.$apipost.get.Getwl_Batch({ paraminfo: paraminfo }).then(res => {
					if(res.state=='0'){
						that.$tool.loadingclose();
						this.$tool.message(res.message, 0);
					}
					//console.log('res',res);
				}).catch(e=>{
					that.Getwl_Batch();
				});
			}
		},
		//列表中的自定义列的操作事件
		gridhandle(e) {
			this.checkedrow = [];
			if (e.event == 'delorder') {
				this.checkedrow.push(this.packagelist[e.index]);
				this.DelOrder();
			}
			if (e.event == 'editorder') {
				var that = this;
				this.$apipost.get.GetLinkInfo({ l_id: e.l_id }).then(res => {
					that.showratewin = false;
					if (res.info != undefined) {
						Utils.$emit('go', {
							l_url: '/packagemanange/createorder_pkg',
							l_id: e.l_id,
							l_name: '修改订单',
							urlparam: { pkval: that.packagelist[e.index].p_pkval, iscopy: 0, l_tablename: res.info.l_tablename}
						});
					} else that.$tool.message('此功能无法启用', 0);
				});
			}
			if (e.event == 'copyorder') {
				var that = this;
				this.$apipost.get.GetLinkInfo({ l_id: e.l_id }).then(res => {
					that.showratewin = false;
					if (res.info != undefined) {
						Utils.$emit('go', {
							l_url: '/packagemanange/createorder_pkg',
							l_id: e.l_id,
							l_name: '复制订单',
							urlparam: { pkval: that.packagelist[e.index].p_pkval, iscopy: 1, l_tablename: res.info.l_tablename }
						});
					} else that.$tool.message('此功能无法启用', 0);
				});
			}
			if (e.event == 'showdetail') {
				Utils.$emit('go', { l_url: '/packagemanange/orderdetail', l_id: e.l_id, l_name: '订单详情', urlparam: { pkval: this.packagelist[e.index].p_pkval, iscopy: 0 } });
			}
			if (e.event == 'delplan') {
				//删除
				this.checkedrow.push(this.packagelist[e.index]);
				this.DelOrderPlan();
			}
			if(e.event=='returnandexchange'){//退换货
				debugger
				//e.urlparam={pkval:this.packagelist[e.index].p_pkval};
				var that = this;
				this.$apipost.get.GetLinkInfo({ l_id: e.l_id }).then(res => {
					if (res.info != undefined) {
						debugger
						var param=
						{
							l_pagetype:res.l_pagetype,
							l_handetype:'opentab',
							urlparam:{pkval:that.packagelist[e.index].p_pkval,iscopy:2},
							l_name:this.baojia_air_lang.flighttitle,
							l_tabname:this.baojia_air_lang.flighttitle,l_tabevent:'',
						};
						this.$public.ActionControl(e,this);
						// Utils.$emit('go', {
						// 	l_url: '/packagemanange/createorder_pkg',
						// 	l_id: e.l_id,
						// 	l_name: e.l_name,
						// 	urlparam: { pkval:'', iscopy: 0, l_tablename: res.info.l_tablename }
						// });
					} else that.$tool.message('此功能无法启用', 0);
				});
				
				
				// var param=
				// {l_pagetype:'flight',
				// l_handetype:'opentab',
				// 	urlparam:{c_id:c_id},
				// 	l_name:this.baojia_air_lang.flighttitle,
				// 	l_tabname:this.baojia_air_lang.flighttitle,l_tabevent:''}
				// ;
				
				// this.$public.ActionControl({l_pagetype:'flight',l_handetype:'opentab',
				// 	urlparam:{c_id:c_id},l_name:this.baojia_air_lang.flighttitle,l_tabname:this.baojia_air_lang.flighttitle},this);
				
				// this.$public.ActionControl(e,this);
			}
		},
		//获取常用筛选条件
		GetFilter() {
			var that = this;
			this.$apipost.get.GetFilter({ l_mode: this.mode, type: this.tabs[this.activeTabIndex].type }).then(res => {
				if (res != '') {
					that.filterlist = res.data;
				}
			});
		},
		//设置常用筛选
		Setfilterchecked(value) {
			this.searchlist.fname = value;
		},
		//复选框勾选触发
		checkboxchange(e) {
			if (!e.selectedall) {
				this.checkedrow = e.rows; //勾选了的列表
			}
			this.selectedall = e.selectedall;
		},
		//导入订单
		InportOrder(e) {
			Utils.$emit('go', {
				l_url: '/packagemanange/orderimport',
				l_name: '批量下单',
				l_id: e.l_id,
				urlparam: { tab: this.tabs[this.activeTabIndex].type, mode: '包裹管理导入', l_name: '批量下单' }
			});
		},
		//删除订单方法1/2
		DelOrder(e) {
			var searchinfo = this.GetCheckedOrder(true);
			if (searchinfo != '') {
				var that = this;
				this.$confirm('确定删除所选订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				})
					.then(() => {
						//debugger
						this.$tool.loading('正在获取勾选数据', 'packagelist');
						this.$apipost.post.InsertTemp({ l_mode: that.mode, tab: that.tabs[that.activeTabIndex].type, search: searchinfo, sort: that.sort }).then(res => {
							this.$tool.loadingclose();
							if (res != '') {
								if (res.batch != '') {
									this.$tool.loading('正在删除', 'packagelist');
									that.DelOrder2(res.batch);
								} else {
									this.$tool.message('获取数据失败', 0);
								}
							} else {
								this.$tool.message('获取数据失败', 0);
							}
						});
					})
					.catch(() => {});
			} else {
				if (that.$refs.pastorderwin != undefined) {
					that.$refs.pastorderwin.init({
						l_mode: that.mode,
						fun: '删除'
					});
				}
			}
		},
		//删除订单方法2/2
		DelOrder2(batch) {
			var that = this;
			console.log('删除订单', batch);
			console.log('this.mode', this.mode);
			this.$apipost.post.SetOrderToTrash({ l_mode: this.mode, batch: batch, pkval: '', type: 1 }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('操作成功', 1);
					that.refreshgrid(true);
					that.GetPackageCount(); //获取汇总数
				} else {
					this.$tool.message(res.message, 0);
				}
			});
		},
		//删除订单方法1/2
		DelOrderPlan(e) {
			var searchinfo = this.GetCheckedOrder(true);
			if (searchinfo != '') {
				var that = this;
				this.$confirm('确定删除所选订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				})
					.then(() => {
						//debugger
						this.$tool.loading('正在获取勾选数据', 'packagelist');
						this.$apipost.post.InsertTemp({ l_mode: that.mode, tab: that.tabs[that.activeTabIndex].type, search: searchinfo, sort: that.sort }).then(res => {
							this.$tool.loadingclose();
							if (res != '') {
								if (res.batch != '') {
									this.$tool.loading('正在删除', 'packagelist');
									that.DelOrderPlan2(res.batch);
								} else {
									this.$tool.message('获取数据失败', 0);
								}
							} else {
								this.$tool.message('获取数据失败', 0);
							}
						});
					})
					.catch(() => {});
			} else {
				if (that.$refs.pastorderwin != undefined) {
					that.$refs.pastorderwin.init({
						l_mode: that.mode,
						fun: '删除订单'
					});
				}
			}
		},
		//删除订单方法2/2
		DelOrderPlan2(batch) {
			var that = this;
			var paraminfo = {
				batch:batch,
				userid: localStorage.getItem('userid')
			};
			this.$apipost.post.DelStockOut_Plan({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('操作成功', 1);
					that.refreshgrid(true);
				} else {
					if(res.filename!=undefined)
						this.$tool.downfile(that,res.filename,batch);
					this.$tool.message(res.message, 0);
				}
			});
		},
		//重置筛选
		ResetFilterInfo() {
			this.ClearSearch(1); //先清空筛选条件
			this.refreshgrid(true);
		},
		//获取勾选数据组合json
		GetCheckedOrder(isempty) {
			var pkval = '';
			var isgo = true;
			var search = {
				p_pkval: ''
			};
			var searchinfo = '';
			if (!this.selectedall) {
				if (this.tabs[this.activeTabIndex].isgridexpand) {
					this.checkedrow.forEach(e => {
						pkval += e.groupid + ',';
					});
					if (pkval != '') {
						pkval = pkval.substring(0, pkval.length - 1);
						search.groupid = pkval; //这里的筛选条件对象的结构与订单筛选条件结构一致
						searchinfo = JSON.stringify(search);
					} else {
						if (!isempty) this.$tool.message('请勾选订单', 2);
					}
				} else {
					this.checkedrow.forEach(e => {
						pkval += e.p_pkval + ',';
					});
					if (pkval != '') {
						pkval = pkval.substring(0, pkval.length - 1);
						search.p_pkval = pkval; //这里的筛选条件对象的结构与订单筛选条件结构一致
						searchinfo = JSON.stringify(search);
					} else {
						if (!isempty) this.$tool.message('请勾选订单', 2);
					}
				}
			} else {
				searchinfo = this.GetSearchObj();
			}
			return searchinfo;
		},
		//粘贴获取订单
		pastorderhandler(e) {
			var that = this;
			if (e.fun == '打印') {
				this.$tool.loading('正在打印', 'packagelist');
				if (this.$refs.printhandler != undefined) {
					this.$refs.printhandler.init({
						pageparam: this._data,
						isgrid: true,
						pkval: '',
						searchinfo: '',
						funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
						handtype: 12, //1--取单号 2--取快递单并打印 3-取快递单并预览
						isrollback: false,
						parentpage: this,
						batch: e.checkedbatch,
						isprint: 1
					});
				}
			}
			if (e.fun == '取单号') {
				this.$tool.loading('正在获取', this.divclass);
				if (this.$refs.printhandler != undefined) {
					this.$refs.printhandler.init({
						pageparam: this._data,
						isgrid: true,
						pkval: '',
						searchinfo: '',
						funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
						handtype: 11, //1--取单号 2--取快递单并打印 3-取快递单并预览
						isrollback: false,
						parentpage: this,
						batch: e.checkedbatch,
						isprint: 0,
						iserror:false,//操作过程中报错不显示，最后才显示
						isorder:false //是否按顺序操作，true 表示单线程按序操作， false 表示多线程操作
					});
				}
			}
			if (e.fun == '预览') {
				this.$tool.loading('正在预览', 'packagelist');
				if (this.$refs.printhandler != undefined) {
					this.$refs.printhandler.init({
						pageparam: this._data,
						isgrid: true,
						pkval: '',
						searchinfo: '',
						funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
						handtype: 12, //1--取单号 2--取快递单并打印 3-取快递单并预览
						isrollback: false,
						parentpage: this,
						batch: e.checkedbatch,
						isprint: 0
					});
				}
			}
			if (e.fun == '删除') {//包裹订单删除
				var batch = e.checkedbatch;
				this.$confirm('确定删除输入的订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.DelOrder2(batch);
				});
			}
			if (e.fun == '删除订单') {//计划单删除
				var batch = e.checkedbatch;
				this.$confirm('确定删除输入的订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.DelOrderPlan2(batch);
				});
			}
			if (e.fun == '预报') {
				this.$tool.loading('预报', 'packagelist');
				if (this.$refs.printhandler != undefined) {
					this.$refs.printhandler.init({
						pageparam: this._data,
						isgrid: true,
						pkval: '',
						searchinfo: '',
						funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
						handtype: 1, //1--取单号 2--取快递单并打印 3-取快递单并预览
						isrollback: false,
						parentpage: this,
						batch: e.checkedbatch
					});
				}
			}
			if (e.fun == '自定义导出') {
				var batch = e.checkedbatch;
				if (this.$refs.exportwin != undefined) {
					this.$refs.exportwin.init({
						batch: batch,
						pageparam: this._data,
						handtype: 1
					});
				}
			}
			if (e.fun == '拦截') {
				if (that.$refs.interceptwin != undefined) {
					that.$refs.interceptwin.init({
						batch: e.checkedbatch,
						pageparam: this._data
					});
				}
			}
			if (e.fun == '取消拦截') {
				that.Cancelintercept({ batch: e.checkedbatch });
			}
			if (e.fun == '导出') {
				debugger
				var batch = e.checkedbatch;
				if (this.$refs.exportwin != undefined) {
					this.$refs.exportwin.init({
						batch: batch,
						pageparam: this._data,
						handtype: 1
					});
				}
			}
			if (e.fun == '批量更新') {
				var batch = e.checkedbatch;
				that.$refs.BatchUpdate.init({
					title: '批量更新',
					pageparam: that._data,
					batch: batch,
					pkcol: 'p_pkval',
					isgrid: true
				});
			}
			if (e.fun == '更新状态') {
				var batch = e.checkedbatch;
				that.$refs.BatchUpdate.init({
					title: '更新状态',
					pageparam: that._data,
					batch: batch,
					pkcol: 'p_pkval',
					isgrid: true
				});
			}
			if (e.fun == '下载面单') {
				var batch = e.checkedbatch;
				if (that.$refs.downmd != undefined) {
					that.$refs.downmd.init({
						pageparam: that._data,
						batch: batch
					});
				}
			}
			if (e.fun == '清空快递') {
				var batch = e.checkedbatch;
				that.ClearExpress('',batch);
			}
			if (e.fun == '验证号码') {
				var batch = e.checkedbatch;
				that.verifyid('',batch);
			}
			if (e.fun == '智能翻译') {
				var batch = e.checkedbatch;
				that.Translationorder('',batch);
			}
			if (e.fun == '生成清关报文') {
				var batch = e.checkedbatch;
				if(that.$refs.exportxml_clear!=undefined)
					that.$refs.exportxml_clear.init({pageparam:this._data,batch:batch,xmltype:'import'});
			}
			if (e.fun == '生成出口报文') {
				var batch = e.checkedbatch;
				if(that.$refs.exportxml_clear!=undefined)
					that.$refs.exportxml_clear.init({pageparam:this._data,batch:batch,xmltype:'export'});
			}
			if(e.fun=='生成物流')
			{
				var batch=e.checkedbatch;
				if(this.$refs.createstep!=undefined)
					this.$refs.createstep.init({batch:batch});
			}
			if(e.fun=='推送物流')
			{
				var batch=e.checkedbatch;
				if(this.$refs.pushwl!=undefined)
					this.$refs.pushwl.init({batch:batch,sendcode:this.sendcode,pageparam:this._data});
			}
			if(e.fun=='订单推送')
			{
				this.$tool.loading('正在推送', this.divclass);
				if (this.$refs.printhandler != undefined) {
					this.$refs.printhandler.init({
						pageparam: this._data,
						isgrid: true,
						pkval: '',
						searchinfo: '',
						funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
						handtype: 11, //1--取单号 2--取快递单并打印 3-取快递单并预览
						isrollback: false,
						parentpage: this,
						batch: e.checkedbatch,
						isprint: 0,
						istransorder:true
					});
				}
			}
			if(e.fun=='订阅物流')
			{
				var batch=e.checkedbatch;
				that.SubWl('',batch);
			}
			// if(e.fun=='推送报文')
			// {
			// 	var batch=e.checkedbatch;
			// 	if(that.$refs.submitqg!=undefined)
			// 		that.$refs.submitqg.init({batch:batch,pageparam:pageparam});
			// }
		},
		//取消拦截
		Cancelintercept(paraminfo) {
			var that = this;
			this.$tool.loading('正在取消拦截', 'packagelist');
			this.$apipost.post.Cancelintercept({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message(res.message, 1);
				} else {
					this.$tool.message(res.message, 0);
				}
			});
		},
		//列表双击事件
		rowdblclick(e) {
			Utils.$emit('go', { l_url: '/packagemanange/orderdetail', l_id: '', l_name: '订单详情', urlparam: { pkval: e.row.p_pkval, iscopy: 0 } });
		},
		//导出
		ExportOrder() {
			debugger
			var that = this;
			var searchinfo = this.GetCheckedOrder(true);
			if (searchinfo != '') {
				if (that.$refs.exportwin != undefined) {
					that.$refs.exportwin.init({
						searchinfo: searchinfo,
						pageparam: that._data,
						handtype: 1
					});
				}
			} else {
				if (that.$refs.pastorderwin != undefined) {
					that.$refs.pastorderwin.init({
						l_mode: that.mode,
						fun: '自定义导出'
					});
				}
			}
		},
		//列表展开时加载子表信息
		getExpandsRow(e) {
			
			e.row.expand = e.expand;
			if (e.expand) {
				//加载子表信息
				this.loadsongrid(e.row, e.index);
			}
		},
		loadsongrid(row, index) {
			var that = this;
			var search = {
				groupid: row.groupid
			};
			//debugger
			this.loading = true;
			this.$apipost.get
				.GetPackageList({
					search: JSON.stringify(search),
					tab: this.tabs[this.activeTabIndex].type,
					pageindex: 0,
					pagesize: 300,
					sort: '',
					l_mode: this.mode + '子表',
					showcol: JSON.stringify(this.tabs[this.activeTabIndex].soncolumns)
				})
				.then(reslist => {
					//debugger
					that.packagelist[index].sonDataList=reslist.data;
					that.loading = false;
					that.$refs.packagetableexpand[that.activeTabIndex].SetExpandSonList(index, reslist.data);
				});
		},
		
		printcallback(e) {
			var pkval = '',
				batch = '';
			var that=this;
			if(e.thread==undefined)
				e.thread=false;
			if(e.thread){
				//debugger
				this.threadPrint(e.paraminfo);
			}else{
				if(e.issuccess){
					if (e.p_pkval != ''&&e.p_pkval!=undefined) {
						pkval = e.p_pkval;
					}
					if (e.batch != ''&&e.batch!=undefined) {
						batch = e.batch;
					}
					if (e.handtype == 13) {
						var paraminfo = {
							p_pkval: pkval,
							batch: batch
						};
						//更新打印状态和打印次数
						this.$apipost.post.UpdatePrintState({ paraminfo: paraminfo }).then(res => {
							//获取订单详情
							if(pkval!=''){
								that.$apipost.get.GetOrderInfoByCountry({paraminfo:{pkval:pkval,
						userid:localStorage.getItem('userid')}}).then(res => {
									if(res.state=='1'){
										var cargolist=res.cargolist;
										cargolist.forEach(e=>{
											if(e.search_pic!=''&&e.search_pic!=undefined)
												e.search_pic=decodeURIComponent(e.search_pic);
										});
										var orderinfo=res;
										orderinfo.cargolist=cargolist;
										//debugger
										this.$tool.SendEmailMsg(
										{msgid:e.l_id+'-1',info:res.orderinfo,pkval:pkval,type:'1-q',showerror:false},this);
									}
								});
							}
						});
					}
					if(e.istransorder){
						if(batch!='')
							pkval='';
						//订单转换表状态
						this.$tool.ChangeOrderState(that,pkval,batch,'dy');
					}
				}
			}
		},
		sethandlepercent(){
			if(parseInt(this.handlercount)<=parseInt(this.allcount))
				this.handlerpercent=parseInt(parseInt(this.handlercount)/parseInt(this.allcount)*100);
		},
		threadPrint(paraminfo){
			var that=this;
			//单数多的，分次提交
			//debugger
			var allcount=paraminfo.orderlist.length;
			// var chunk=1;
			// if(allcount%100==0)
			// 	chunk= allcount/100;
			// else
			// 	chunk= parseInt(allcount/100)+1;
				
			var orderlist=JSON.parse(JSON.stringify(paraminfo.orderlist));
			paraminfo.allcount=allcount;
			if(paraminfo.batch==undefined)
				paraminfo.batch=this.$tool.getGuid();
			
			that.allcount=allcount;
			if(that.allcount>0){
				paraminfo.e_code=orderlist[0].e_code;
				that.showthreadwin=true;
			}
			paraminfo.orderlist=undefined;
			
			that.threadparaminfo=JSON.parse(JSON.stringify(paraminfo));
			that.threadparaminfo.orderlist=undefined;
			
			that.getMailno(paraminfo,false,0);
			that.CheckOrderHandleState(paraminfo);
		},
		//取单号
		getMailno(paraminfo,isreget,i){		
			//console.log('orderlist-'+i,paraminfo.orderlist);
			var that=this;
			var threadparam=JSON.parse(JSON.stringify(paraminfo));
			if(isreget==undefined)
				isreget=false;
			threadparam.isreget=isreget;
			that.sethandlepercent();
			//debugger
			//console.log('多线程提交',encodeURIComponent(JSON.stringify(threadparam)));
			//return false;
			that.$apipost.post.ThreadPrint({ paraminfo:threadparam }).then(res =>{
				//console.log('提交完成  '+this.$tool.formatdate()+'  是否超10秒重调'+isreget,res);
				if(isreget){
					if(res.state=='1'){
						that.showthreadwin=false;
						that.handlercount=0;
						that.threadparaminfo='';
						that.refreshgrid(true);
						this.$tool.message('操作完成', 1);
					}else if(res.state=='0'){
						if(res.filename!=undefined)
							that.errorfilename=res.filename;

						if(that.errorfilename!=''){
							that.showthreadwin=false;
							this.$tool.downfile(that,that.errorfilename,res.batch);
							this.$tool.alertmessage('操作完成！下单报错文件已下载，请查看');
							that.refreshgrid(true);
						}else
						{
							if(res.message!=undefined){
								that.showthreadwin=false;
								this.$tool.alertmessage(res.message);
							}
							else
								that.CheckOrderHandleState(threadparam);
						}
					}else
						that.CheckOrderHandleState(threadparam);
				}
			}).catch(e=>{
				that.getMailno(threadparam,true);
				// if(e.toString().indexOf('timeout')>-1){
				// 	console.log('getMailno 超时重调 '+this.$tool.formatdate());
				// 	threadparam.resubmit=1;
				// 	that.getMailno(threadparam,isreget,i);
				// }else{
				// 	that.threadparaminfo='';
				// 	that.showthreadwin=false;
				// 	var message='网络异常，请重试';
				// 	this.$tool.alertmessage(message);
				// }
			});
		},
		CheckOrderHandleState(paraminfo){
			var that=this;
			var threadparam=JSON.parse(JSON.stringify(paraminfo));
			//debugger
			//console.log('检测状态 '+that.handlercount+'  '+this.$tool.formatdate());
			that.$apipost.get.CheckOrderHandleState({ batch:paraminfo.batch,allcount:paraminfo.allcount}).then(res =>{
				//console.log('状态结果 '+this.$tool.formatdate(),res);
				if(res.state=='1')
				{
					that.showthreadwin=false;
					that.handlercount=0;
					that.threadparaminfo='';
					that.refreshgrid(true);
					this.$tool.message('操作完成', 1);
				}
				else{
					//debugger
					if(res.filename!=undefined)
						that.errorfilename=res.filename;
					
					if(that.errorfilename!=''){
						that.showthreadwin=false;
						this.$tool.downfile(that,that.errorfilename,res.batch);
						this.$tool.alertmessage('操作完成！下单报错文件已下载，请查看');
						that.refreshgrid(true);
					}else{
						// setTimeout(function(){
						//  	that.CheckOrderHandleState(threadparam);
						// },500);
						if(that.handlercount!=parseInt(res.count)){
							that.handlercount=parseInt(res.count);
							that.sethandlepercent();
							that.changetime='';
							//console.log('条数在变化 '+this.$tool.formatdate(),paraminfo);
							setTimeout(function(){
								that.CheckOrderHandleState(threadparam);
							},500);
						}else{
							if(that.changetime==''){
								that.changetime=this.$tool.formatdate();
								//console.log('条数没变化 '+this.$tool.formatdate(),paraminfo);
								setTimeout(function(){
									that.CheckOrderHandleState(threadparam);
								},500);
							}else{
								var currenttime= new Date(this.$tool.formatdate());
								var oldtime=new Date(that.changetime);
								var compareTime = currenttime - oldtime  // 时间差的毫秒数
								if(compareTime>10000){
									console.log('超过10s重调 '+this.$tool.formatdate(),that.threadparaminfo);
									that.changetime=this.$tool.formatdate();
									//that.threadparaminfo.orderlist=undefined;
									//debugger
									that.getMailno(that.threadparaminfo,true);
								}else{
									//console.log('还在10秒内 '+compareTime,paraminfo);
									setTimeout(function(){
										that.CheckOrderHandleState(threadparam);
									},500);
								}
							}
						}
					}
				}
			}).catch(e=>{
				if(e.toString().indexOf('timeout')>-1){
					console.log('CheckOrderHandleState 超时重调 '+this.$tool.formatdate());
					that.CheckOrderHandleState(threadparam);
				}else{
					that.threadparaminfo='';
					that.showthreadwin=false;
					var message='网络异常，请重试';
					this.$tool.alertmessage(message);
				}
			});
		},
		//清空快递
		ClearExpress(searchinfo,batch){
			var that=this;
			this.$confirm('确定清空所选订单的快递信息吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			})
				.then(() => {
					that.ClearExpress2(searchinfo,batch);
			});
		},
		ClearExpress2(searchinfo,batch){
			var that = this;
			var paraminfo={
				searchinfo:searchinfo,
				mode:this.mode,
				userid:localStorage.getItem('userid'),
				activeName:that.tabs[that.activeTabIndex].type,
				sort:this.sort,
				batch:batch
			}
			this.$tool.loading('正在清空', 'packagelist');
			this.$apipost.post.ClearExpress({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('操作成功', 1);
				} else {
					this.$tool.message(res.message, 0);
				}
			});
		},
		//验证号码
		verifyid(searchinfo,batch){
			var that = this;
			var paraminfo={
				searchinfo:searchinfo,
				mode:this.mode,
				userid:localStorage.getItem('userid'),
				activeName:that.tabs[that.activeTabIndex].type,
				sort:this.sort,
				batch:batch
			}
			this.$tool.loading('正在验证', 'packagelist');
			this.$apipost.post.Verifyid({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('操作成功', 1);
				} else {
					if(res.filename!=undefined)
					{
						that.$tool.downfile(that,res.filename);
					}
					this.$tool.message(res.message, 0);
				}
			}).catch((err) => {
				this.$tool.loadingclose();
				this.$tool.message('网络异常，请重试', 0);
			});
		},
		//智能翻译
		Translationorder(searchinfo,batch){
			var that = this;
			var paraminfo={
				searchinfo:searchinfo,
				mode:this.mode,
				userid:localStorage.getItem('userid'),
				activeName:that.tabs[that.activeTabIndex].type,
				sort:this.sort,
				batch:batch,
				from:'zh',
				to:'en',
				type:'1'//1-寄件地址省市区和收件地址省市区都是中文的翻译为拼音，详细地址翻译为英文 2-翻译寄件地址省市区为翻译为拼音，收件地址省市区翻译为英文，详细地址翻译为英文
			}
			this.$tool.loading('正在翻译', 'packagelist');
			this.$apipost.post.Translationorder({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('翻译完成', 1);
				} else {
					this.$tool.message(res.message, 0);
				}
			}).catch((err) => {
				this.$tool.loadingclose();
				this.$tool.message('网络异常，请重试', 0);
			});
		}
	}
};
</script>
